import { IOpenIdRedirect } from '@goparrot/dashboard-gateway-sdk';

export const ssoLoginRedirectSuccess = (res: IOpenIdRedirect): void => {
  const { url } = res;
  location.href = url;
};
